/**
 * @class Appearance
 *
 * @description This class works with an object with the following format:
 *
 *  ```
 *  AppearanceItem = {
 *    component: 'ComponentName',
 *    properties: Properties,
 *    children: List<AppearanceItem>
 *  }
 *  ```
 *
 * In this case, a `Properties` is a simple object with
 * different keys and values, without a particular format.
 */
class Appearance {
  constructor(appearance) {
    this.appearance = appearance;
  }

  fromTreeGetComponentByName(tree, name) {
    let result = null;

    if (tree) {
      if (tree.component === name || tree.component === `${name}Editable`) {
        return tree;
      }

      if (tree.children && tree.children.length > 0) {
        tree.children.find((child) => {
          result = this.fromTreeGetComponentByName(child, name);
          return result;
        });
      }
    }

    return result;
  }

  navigateToProperty(props, prop) {
    const splitted = prop.split(/\.(.+)/, 2);

    if (!props) { // no props? nothing to look for
      return null;
    }

    if (splitted.length === 1) {
      return props[splitted[0]];
    }

    return this.navigateToProperty(props[splitted[0]], splitted[1]);
  }

  getComponentByName(name) {
    return this.fromTreeGetComponentByName(this.appearance, name);
  }

  getComponentProperty(name, property) {
    const component = this.getComponentByName(name);
    if (component && component.properties) {
      return this.navigateToProperty(component.properties, property);
    }

    return null;
  }
}

module.exports = Appearance;
